<template>
	<section class="section">
		<div class="container-fluid">
			<card ref="card" title="" icon="">
				<form-field label="企業" sub="" :has-wrap="false">
					<div class="field">
						<b-select class="" v-model="customerId">
							<option
								v-for="(c, index) in customers"
								:value="c.id"
								:key="index">
								{{ c.name }}
							</option>
						</b-select>
					</div>
				</form-field>

				<form-field label="グループ名" sub="必須" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
						<input class="input" :class="{'is-danger': hasError('name')}" type="text" v-model="name">
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('name')">{{ errors.name }}</p>
					</div>
				</form-field>

				<form-field class="mt-20" label=" " sub=" " :has-wrap="false">
					<b-checkbox v-model="isHidden">システム上で非表示にする</b-checkbox>
				</form-field>

				<form-field :has-wrap="false">
					<div class="edit-buttons">
						<b-button type="is-light" @click="onBackButtonClick">戻る</b-button>
						<b-button type="is-success" :loading="isLoading" @click="onRegisterButtonClick">登録</b-button>
					</div>
				</form-field>
			</card>
		</div>
	</section>
</template>

<script>
import Card from '@/components/Card'
import FormField from '@/components/FormField'

export default {
	name: "group-edit",
	components: {
		Card,
		FormField,
	},
	data() {
		return {
			isLoading: false,
			id: '',
			name: '',
			customerId: '',
			isHidden: false,
			customers: [],
			errors: {
				name: '',
			}
		}
	},
	computed: {
	},
	mounted() {
		let subTitle = this.$route.params.groupId ? '更新' : '新規作成';
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['グループ管理', subTitle]
		})
		this.getData();
	},
	methods: {
		hasError: function(key) {
			return this.errors[key] !== '';
		},
		getData: async function() {
			let loading = this.$loading.open();
			let params = this.$route.params.groupId ? '/' + this.$route.params.groupId : '';
			let ep = 'groups/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.name = res.data.name;
				this.isHidden = res.data.is_hidden;
				this.customerId = res.data.customer_id;
				this.customers = res.data.customers;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loading.close();
			}
		},
		onRegisterButtonClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"id": this.id,
				"name": this.name,
				"customer_id": this.customerId,
				"is_hidden": this.isHidden ? 1 : 0,
			};
			this.$utils.log(data);

			let ep = 'groups';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$router.push({ name: 'group' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		onBackButtonClick: function() {
			this.$router.go(-1);
		},
	}
}
</script>

<style scoped>
</style>
